'use client';

import { Box } from '@wishket/design-system';
import { forwardRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { twMerge } from 'tailwind-merge';

import { ShareBoxProps } from './ShareBox.types';
import { ShareIcon } from './ShareBox.parts';

import {
  copyToClipboard,
  openFacebookSharePopup,
  openLinkedInSharePopup,
  openNaverSharePopup,
  openTwitterSharePopup,
} from '@/shared/utils';

const ShareBox = forwardRef<HTMLDivElement, ShareBoxProps>(
  ({ url, title, className }: ShareBoxProps, ref) => {
    const linkParams = { url, title };

    return (
      <AnimatePresence>
        <motion.div
          ref={ref}
          initial={{ scale: 0, zIndex: 20, position: 'relative' }}
          animate={{ scale: 1, zIndex: 10, position: 'relative' }}
        >
          <Box
            data-testid="share-box"
            className={twMerge(
              'w-max rounded-xl bg-white p-2 shadow-graymedium',
              className
            )}
          >
            <Box className="flex">
              <ShareIcon
                name="트위터"
                icon="social_x"
                onClick={() => openTwitterSharePopup(linkParams)}
              />
              <ShareIcon
                name="페이스북"
                icon="social_facebook"
                onClick={() => openFacebookSharePopup(linkParams)}
              />
            </Box>
            <Box className="flex">
              <ShareIcon
                name="네이버"
                icon="social_naver"
                onClick={() => openNaverSharePopup(linkParams)}
              />

              <ShareIcon
                name="링크드인"
                icon="social_linked_in"
                onClick={() => openLinkedInSharePopup(linkParams)}
              />
            </Box>
            <ShareIcon
              name="URL"
              icon="medium_link"
              onClick={async () =>
                await copyToClipboard(url, 'URL이 클립보드에 복사되었습니다.')
              }
            />
          </Box>
        </motion.div>
      </AnimatePresence>
    );
  }
);

ShareBox.displayName = 'ShareBox';

export default ShareBox;
